var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 5.4502C3.50368 5.4502 3 5.95387 3 6.5752V17.8252C3 18.4465 3.50368 18.9502 4.125 18.9502H19.875C20.4963 18.9502 21 18.4465 21 17.8252V6.5752C21 5.95387 20.4963 5.4502 19.875 5.4502H4.125ZM1.5 6.5752C1.5 5.12545 2.67525 3.9502 4.125 3.9502H19.875C21.3247 3.9502 22.5 5.12545 22.5 6.5752V17.8252C22.5 19.2749 21.3247 20.4502 19.875 20.4502H4.125C2.67525 20.4502 1.5 19.2749 1.5 17.8252V6.5752Z",
    fill: "#809199"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65802 7.23977C4.91232 6.91281 5.38353 6.85391 5.71049 7.10822L12 12.0001L18.2896 7.10822C18.6165 6.85391 19.0877 6.91281 19.342 7.23977C19.5964 7.56673 19.5375 8.03794 19.2105 8.29224L12.4605 13.5422C12.1897 13.7529 11.8104 13.7529 11.5396 13.5422L4.78958 8.29224C4.46262 8.03794 4.40372 7.56673 4.65802 7.23977Z",
    fill: "#809199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.c6055fd0ebd24072892a12f718c3026e.svg";
export { ForwardRef as ReactComponent };